import React, { useMemo } from 'react';
import { Formik, Field, ErrorMessage, FieldProps } from 'formik';
import { Button, Form, Grid, Header, Message, Segment } from 'semantic-ui-react';
import { IWorkstation } from '@relab/alstom-ptw-shared';

import { ServerRequestStatus } from '../../redux/types';
import { TranslationComponent } from '../TranslationComponent';
import { useTranslation } from 'react-i18next';
import { CreateWorkstationSchema } from './WorkstationSchema';

interface WorkstationCreateComponentProps {
  onCreateWorkstation: any;
  createWorkstationServerRequest?: ServerRequestStatus;
}

export const WorkstationCreateComponent = ({
  onCreateWorkstation,
  createWorkstationServerRequest,
}: WorkstationCreateComponentProps) => {
  const handleSubmit = (values: Partial<IWorkstation>) => {
    onCreateWorkstation(values);
  };

  const { t } = useTranslation();

  const validationSchema = useMemo(() => CreateWorkstationSchema(t), [t]);

  const initialValues = {
    name: '',
  };

  return (
    <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
      {({ handleSubmit, isSubmitting, resetForm }) => (
        <Form
          size="large"
          error
          loading={isSubmitting && createWorkstationServerRequest && createWorkstationServerRequest.pending}
          onSubmit={handleSubmit}
        >
          <Segment>
            <Header as="h2">
              <TranslationComponent stringKey={'New Workstation'} />
            </Header>

            <Grid columns="equal">
              <Grid.Row>
                <Grid.Column>
                  <Field name="name">
                    {({ field }: FieldProps) => <Form.Input placeholder={t('Workstation name')} fluid {...field} />}
                  </Field>
                  <ErrorMessage name="name">{(msg) => <Message error content={msg} />}</ErrorMessage>
                </Grid.Column>
                <Grid.Column>
                  <Button primary fluid size="large" type="submit">
                    <TranslationComponent stringKey={'Create workstation'} />
                  </Button>
                  {createWorkstationServerRequest && createWorkstationServerRequest.success && (
                    <React.Fragment>
                      <Message content={t('Workstation created')} />
                      <Button fluid size="large" onClick={() => resetForm()}>
                        Reset
                      </Button>
                    </React.Fragment>
                  )}
                  {createWorkstationServerRequest && createWorkstationServerRequest.error && (
                    <Message error content={createWorkstationServerRequest.error} />
                  )}
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Segment>
        </Form>
      )}
    </Formik>
  );
};
